import { FormCheckbox } from 'components/common/json_form';
import styled from 'styled-components';

export const StyledSearchHeader = styled.section`
  > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 6px 25px 8px;
    + div {
      border-bottom: 1px solid #ddd;
      display: block;
      padding: 0;
      > section {
        padding: 8px 24px;
      }
    }
    &:first-child:last-child {
      display: block;
      padding: 0;
    }
  }
`;

export const StyledSearchCheckboxes = styled.section`
  display: flex;
  justify-content: flex-end;
  gap: 26.8px;
  flex: 1 1 auto;
`;

export const StyledFormCheckbox = styled(FormCheckbox)`
  align-items: center;
  font-family: var(--FONT_SERIF);
  font-size: 16px;
  display: flex;
  > input {
    font-size: 0.8335em;
  }
`;

export interface StyledSearchContentProps {
  hasHeader?: boolean;
}

export const StyledSearchResults = styled.section<StyledSearchContentProps>`
  flex: 1;
  padding: 35px 76px 48px;
  /* border-radius: ${props =>
    props.hasHeader ? '0px 0px 8px 8px' : '8px'}; */
  /* box-shadow: ${props =>
    props.hasHeader ? 'none' : '0 6px 50px 0 rgba(0, 0, 0, 0.05)'}; */
  /* background-color: white; */
`;

export const StyledSearchContent = styled.section`
  background: white;
  border-radius: 8px;
`;
